export function createPainelApi({
  state,
  fetchImpl = globalThis.fetch,
  notify = () => {},
  logger = console,
} = {}) {
  if (!state) {
    throw new Error('createPainelApi requires a state object');
  }

  state.dadosCache = state.dadosCache || {};
  state.agregadosCache = state.agregadosCache || {};

  async function fetchDados(municipio, ano, options = {}) {
    const key = `${municipio}_${ano}`;
    if (state.dadosCache[key]) return state.dadosCache[key];
    const silent = options.silent === true;

    try {
      const res = await fetchImpl(`/api/public/dados?municipio=${encodeURIComponent(municipio)}&ano=${ano}`, {
        credentials: 'same-origin',
      });
      if (res.status === 401) {
        if (!silent) notify('Dados indisponíveis para acesso público.', 'error');
        return null;
      }
      if (!res.ok) {
        if (!silent) notify('Erro ao carregar dados. Tente novamente em instantes.', 'error');
        return null;
      }
      const data = await res.json();
      state.dadosCache[key] = data;
      return data;
    } catch (err) {
      logger?.error?.('[Painel] Erro fetch:', err);
      if (!silent) notify('Erro de rede ao carregar dados.', 'error');
      return null;
    }
  }

  async function fetchAgregado(municipio, ano, options = {}) {
    const scope = options.scope === 'zona' ? 'zona' : 'municipio';
    const cargo = options.cargoKey || '';
    const zona = options.zona || '';
    const page = options.page || 1;
    const pageSize = options.pageSize || 15;
    const key = `${municipio}_${ano}_${cargo || 'todos'}_${scope}_${zona || '-'}_${page}_${pageSize}`;
    if (state.agregadosCache[key]) return state.agregadosCache[key];

    const params = new URLSearchParams({
      municipio,
      ano,
      page: String(page),
      page_size: String(pageSize),
      scope,
    });
    if (cargo) params.set('cargo', cargo);
    if (zona) params.set('zona', zona);

    try {
      const res = await fetchImpl(`/api/public/agregados?${params.toString()}`, {
        credentials: 'same-origin',
      });
      if (!res.ok) return null;
      const data = await res.json();
      state.agregadosCache[key] = data;
      return data;
    } catch (err) {
      logger?.warn?.('[Painel] Agregado server-side indisponivel:', err);
      return null;
    }
  }

  async function fetchCatalogo(headers = {}) {
    const res = await fetchImpl('/api/public/catalogo', { headers });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const data = await res.json();
    state.catalogo = data;
    return data;
  }

  return {
    fetchDados,
    fetchAgregado,
    fetchCatalogo,
  };
}
